import {helpers} from 'vuelidate/lib/validators'

// validator for Payload keys
export const payloadKey =
  helpers.regex ('payloadKey', /^([A-Za-z0-9-]+\.)*[A-Za-z0-9-]+$/)
